import React from 'react';
import { useTranslation } from 'react-i18next';

import { TabButton } from '@/js/libs/ui';

import { languageTitle } from 'src/constants';
import { LanguageKey } from 'src/types';

interface LanguageTabsProps {
  value: LanguageKey;
  onChange: (newValue: LanguageKey) => void;
}

export const useDefaultLanguage = (): LanguageKey => {
  const { i18n } = useTranslation(['backend', 'common', 'language']);
  // NOTE: useState is used to be sure the default language stays same even after the language has been changed by user
  const [language] = React.useState<LanguageKey>((i18n.language as LanguageKey) || LanguageKey.German);
  return language;
};

export const useLanguageState = (): [LanguageKey, React.Dispatch<React.SetStateAction<LanguageKey>>] => {
  const defaultLanguage = useDefaultLanguage();
  return React.useState<LanguageKey>(defaultLanguage);
};

export const LanguageTabs: React.FC<LanguageTabsProps> = ({ value, onChange }) => {
  const { t } = useTranslation(['backend', 'common']);
  return (
    <TabButton.Group>
      {(Object.keys(languageTitle) as LanguageKey[]).map((languageKey) => (
        <TabButton
          title={t(languageTitle[languageKey])}
          active={languageKey === value}
          onClick={() => onChange(languageKey)}
          key={languageKey}
        />
      ))}
    </TabButton.Group>
  );
};
